document.addEventListener('DOMContentLoaded', function() {
  if (!window.mz) {
    return
  }
  if (mz.context.filterShow) {
    // placeholder
  }
  function afterUpdate() {
    var drawer = document.getElementById('Search-Drawer');
    if (!drawer || !drawer.classList.contains('active')) {
      return;
    }
    var closeButton = drawer.querySelector('side-panel-close');
    if (closeButton) {
      closeButton.click();
    }
  }
  if (mz.app && mz.app.$bus) {
    mz.app.$bus.on('after-update', afterUpdate)
  }
})
